import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CalendarIcon, BookOpenIcon } from 'lucide-react';
interface BlogPreviewCardProps {
  id: string;
  title: string;
  category: string;
  date: string;
}
export function BlogPreviewCard({
  id,
  title,
  category,
  date
}: BlogPreviewCardProps) {
  return <div className="group relative overflow-hidden rounded-xl shadow-md transition-all duration-500 hover:shadow-xl" data-id="element-51">
      {/* Decorative elements */}
      <div className="absolute -right-12 -top-12 h-24 w-24 rotate-12 transform bg-amber-600 opacity-10 transition-transform duration-500 group-hover:rotate-6" data-id="element-52"></div>
      <div className="absolute -left-6 -bottom-6 h-16 w-16 rotate-45 transform bg-amber-600 opacity-10 transition-transform duration-500 group-hover:rotate-12" data-id="element-53"></div>
      {/* Card content */}
      <div className="relative z-10 flex h-full flex-col bg-white p-6" data-id="element-54">
        <div className="mb-3 flex items-center justify-between" data-id="element-55">
          <span className="rounded-full bg-amber-600 bg-opacity-10 px-3 py-1 text-xs font-medium text-amber-700" data-id="element-56">
            {category}
          </span>
          <span className="flex items-center text-xs text-gray-500" data-id="element-57">
            <CalendarIcon size={14} className="mr-1" data-id="element-58" />
            {date}
          </span>
        </div>
        <div className="mb-4 flex items-center" data-id="element-59">
          <div className="mr-3 flex h-10 w-10 items-center justify-center rounded-full bg-amber-50" data-id="element-60">
            <BookOpenIcon size={18} className="text-amber-600" data-id="element-61" />
          </div>
          <h3 className="text-xl font-bold leading-tight transition-colors group-hover:text-amber-600" data-id="element-62">
            <Link to={`/blog/${id}`} data-id="element-63">{title}</Link>
          </h3>
        </div>
        <div className="mt-auto flex items-center justify-between border-t border-gray-100 pt-4" data-id="element-64">
          <div className="h-1 w-16 rounded-full bg-gradient-to-r from-amber-200 to-amber-600 transition-all duration-300 group-hover:w-24" data-id="element-65"></div>
          <Link to={`/blog/${id}`} className="flex items-center text-gray-900 transition-colors group-hover:text-amber-600" data-id="element-66">
            <span className="font-medium" data-id="element-67">Read</span>
            <ArrowRightIcon size={16} className="ml-2 transition-transform duration-300 group-hover:translate-x-1" data-id="element-68" />
          </Link>
        </div>
      </div>
      {/* Border effect */}
      <div className="absolute inset-0 border-2 border-transparent transition-colors duration-300 group-hover:border-amber-200" data-id="element-69"></div>
    </div>;
}